module.exports = __webpack_public_path__ + "img/HZ-P1020.61b92f1b.jpg";